import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store';
import { setFeatureFlags, setFeatureFlagsReady, selectFeatureFlagsReady, selectFeatureFlags } from '../../store/slices/feature-flags.slice';
import { OrganizationApi } from '../../api';
import { useContainer } from '../useContainer';
import { FeatureFlagsDto } from '../../commonTypes/organization.types';

export const useFeatureFlag = (flagName: string): boolean => {
    const organizationApi: OrganizationApi = useContainer(OrganizationApi);
    const dispatch = useAppDispatch();
    const flags = useAppSelector(selectFeatureFlags);
    const isReady = useAppSelector(selectFeatureFlagsReady);

    useEffect(() => {
        if (!isReady) {
            const { exec, abort } = organizationApi.getFeatureFlags({
                onSuccess: res => {
                    dispatch(setFeatureFlags(res.body));
                    dispatch(setFeatureFlagsReady(true));
                },
                onError: error => {
                    console.error('Failed to fetch feature flags:', error);
                    dispatch(setFeatureFlagsReady(true));
                },
            });
            exec();
            return abort;
        }
    }, [isReady, dispatch]);

    const flag = flags.find((f: FeatureFlagsDto) => f.name === flagName);
    return flag?.enabled ?? false;
};
